var thisProductId;
var topProducts = [];
var bottomProducts = [];
var hasBottomProducts = false;
var hadOneValidSelection = false;

var selectedObject = {
	id	: 0,
	available : false,
	price : 0,
	
};	

var selectedObject2 = {
	id	: 0,
	available : false,
	price : 0,
	
};	


$(document).ready(function() {  
	 //jQuery('body').hide();
	assetUrlArray = assetUrl.split("?"); 
	assetUrl =  assetUrlArray[0];
	//console.log(assetUrl);
	 
	$('.price_lg h4').html(''); 
	greyOutAddToCart();
	 
	console.log(thisProduct); 
	thisProductId = thisProduct.id; 
	var indexOfTopOption = -1;
	
	
	for(var i = 0; i <  thisProduct.options.length; i++){
		//console.log(thisProduct.options[i].toLowerCase());
		if(thisProduct.options[i].toLowerCase() == 'part'){
			indexOfTopOption = i;
		}
	}
	 
	for(i in  thisProduct.variants){
		variant = thisProduct.variants[i]
		variant.prettyName =  '';
		
		
		for(var k = 0; k  <  variant.options.length; k++){
			if(k != indexOfTopOption){
				var append = ' / ';	 
				if(k < variant.options.length-1){
					append = '';	
				}
				variant.prettyName+= variant.options[k]+append;					
			}
			
			
		}
		//variant.prettyName.replace(/\/+$/,'');
		variant.soldHtml = '';
		
		if(variant.inventory_quantity <= 0){
			variant.soldHtml = ' [sold out]';
		}
		
		
		
		if('bottom' == variant.options[indexOfTopOption]){
			variant.isBottom = true;
			
			//if(variant.inventory_quantity > 0){
				bottomProducts.push(variant);		
			//}
		}else{
			variant.isBottom = false;
			//if(variant.inventory_quantity >0){
				topProducts.push(variant);
			//}
		}
		//console.log(variant.options[indexOfTopOption]);
	}
	
	if( bottomProducts.length > 0){
		hasBottomProducts = true
	}
	
	buildSelectors();
	$('#product-form-'+thisProductId+' select').bind("change",function() {
		if(hasBottomProducts == true){	
			syncColorSelection();
		}	
        multiCartCallback();
    });
	
	if(false == thisProduct.available){
		$('.price_lg h4').text(soldOutMessage);
		$('.price_lg h4').append('<br>'+getMoneyFormattedPrice(thisProduct.price));
		$('form .select').remove();
		
	}else{
		setStartingPrice();
	}
});

function setStartingPrice(){	
	
	var price1 = 0;
	var price2 = 0;
	
	for(var i = 0; i <  topProducts.length; i++){
		if(topProducts[i].available == true){
			price1 = topProducts[i].price;
		}
	}
	
	if(hasBottomProducts == true){	
		for(var i = 0; i <  bottomProducts.length; i++){
			
			if(bottomProducts[i].available == true){
				price2 = bottomProducts[i].price;
			}
		}
	}
	
	var comboPrice = price1+ price2;
	if(comboPrice != 0 ){
		$('.price_lg h4').html(getMoneyFormattedPrice(comboPrice));
	}
		
	
}

function multiCartCallback(){		
	//console.log('multiCartCallback');
	
	var finds = getSelectionOfForm('top-products');	
	$('#top-products .sold-out-message').remove();
	if(finds.length > 0){
		updateSelectFeedback(finds[0],selectedObject,'1');		
	}else{
		greyOutAddToCart();
		displaySoldOut('');
		if(hadOneValidSelection == true){
			//$('.price_lg h4').text('');
			//	
		}		
	}
	
	
	if(hasBottomProducts == true){
		finds = getSelectionOfForm('bottom-products');	
		//console.log(hadOneValidSelection);
		if(finds.length > 0){
			updateSelectFeedback(finds[0],selectedObject2,'2');			
		}else{
			greyOutAddToCart();
			displaySoldOut('');
			//console.log(hadOneValidSelection);
			if(hadOneValidSelection == true){
				//$('.price_lg h4').text('');
				//
			}					
		}
	}
}


function allSelectsAreUsed(){
	
	
	//console.log('allSelectsAreUsed --- ');	

	
	if(hasBottomProducts == true){		
		
		if('' == $('#top-products .select-Size').val()){
			return false;
		};
		
		if('' == $('#top-products .select-Color').val()){
			return false;
		};
		
		if('' == $('#bottom-products .select-Size').val()){
			return false;
		};
		
		if('' == $('#bottom-products .select-Color').val()){
			return false;
		};					
		
	}else{
		if('' == $('#top-products .select-Size').val()){
			return false;
		};
		
		if('' == $('#top-products .select-Color').val()){
			return false;
		};
	}	
	
	return true;
	
}

function greyOutAddToCart(){
	//console.log('greyOutAddToCart ');
	$('.my-add').css({'opacity':'0.3'});
	$('.my-add').attr('data-blocked','blocked');	
}

function unGreyAddToCart(){
	$('.my-add').css({'opacity':'1'});
	$('.my-add').attr('data-blocked','ready');
		
}

function updateSelectFeedback(variant,selectObj,debug){
	//console.log('updateSelectFeedback --- '+debug);
	//console.log(variant);
	//console.log('---> ');
	
	if(variant.isBottom == true){
		$('#bottom-products .sold-out-message').remove();
	}else{
		$('#top-products .sold-out-message').remove();
	}
			
	if(variant && variant.available == true) {
        /*
		if(variant.price < variant.compare_at_price){
          $('.compare', $product).html(getMoneyFormattedPrice())        
        } else {
          $('.compare', $product).text('')
        } 
		*/
		selectObj.id = variant.id;
		selectObj.price = variant.price;
		selectObj.available = variant.available;
        selectObj.variantInfo = variant;
        
		var displayPrice =  variant.price;
		// check if two objects selected
		
		//console.log(selectedObject);
		//console.log(selectedObject2);
		if(selectedObject.id != 0 && selectedObject2.id != 0 ){
			displayPrice = selectedObject.price + selectedObject2.price;
		}
		
		if(selectedObject.available != false && selectedObject2.available != false ) {			
			$('.price_lg h4').html(getMoneyFormattedPrice(displayPrice));
			$('.price_lg .ekny-sold-out-message').text('');
			unGreyAddToCart();
			hadOneValidSelection = true;
        }else if(hasBottomProducts == false && selectedObject.available != false){
			$('.price_lg h4').html(getMoneyFormattedPrice(displayPrice));
			$('.price_lg .ekny-sold-out-message').text('');
			unGreyAddToCart();	
			hadOneValidSelection = true;	 
		}else {
			 displaySoldOut(variant);	 
		}
				
        /* CURRENCY */         
        Currency.convertAll('USD', jQuery('#currencies span.selected').attr('data-currency'), 'span.money', 'money_with_currency_format');
        
	}else {
		displaySoldOut(variant);
	}	
	
	
	//$('.price_lg h4').html(getMoneyFormattedPrice(400));
	//$('#cart-feedback').html();
}

function displaySoldOut(variant){
	var message = soldOutMessage; 	
	//console.log('displaySoldOut --- '+allSelectsAreUsed());	
	
	if(hasBottomProducts == true){
		if(variant.isBottom == true){
			//$('#top-products').append('<div class="sold-out-message" >This combination is sold out</div>');
			//$('#bottom-products').append('<div class="sold-out-message" >This combination is sold out</div>');
		}else{
			//$('#top-products').append('<div class="sold-out-message" >This combination is sold out</div>');
		}
	}
	
	if(allSelectsAreUsed()){	
		//$('.price_lg h4').text(message);
		$('.price_lg .ekny-sold-out-message').text(message);
	}
	greyOutAddToCart();
}




function syncColorSelection(){
	
	if(hasBottomProducts == true){
		$('#bottom-products .select-Color').val($('#top-products .select-Color').val());
	}

}


function getSelectionOfForm(key){
	var hasSelection = true;
	//console.log(key);
	var searchFor = {};
	
	$('#'+key+' select').each(function(){		
		searchFor[$(this).attr('name')] = $(this).val();	
		
		if('' == $(this).val()){
			hasSelection = false
		} 
	});	
	//console.log('hasSelection: '+hasSelection);
	//console.log(searchFor);	
	if(hasSelection == true){
		return findProductForSelection(searchFor);
	}else{
		var empty = [];
		return empty;
	}	
	
}


function findProductForSelection(obj){
	//console.log('-----findProductForSelection-------');
	
	var finds = [];
	var counter = 0;		
	for(i in obj){
		//console.log(counter+' '+i+' '+obj[i]);
		if(0 == counter){
			finds = findVariantsByKeyValueInVariantArray(i,obj[i],thisProduct.variants);
		}else{
			if(finds.length > 0){
				finds = findVariantsByKeyValueInVariantArray(i,obj[i],finds);
			}		
		}
		//console.log('--- '+finds.length);
		//console.log(finds);
		counter++;
	}	
	return finds;
}


function findVariantsByKeyValueInVariantArray(key,value,variantArray){
	// we need to set the index of the key, because the options of a variant are not indexed
	// so we take the index from the product options 
	var result = [];
	var index = -1;
	for(var i = 0; i <  thisProduct.options.length; i++){
		if(thisProduct.options[i] == key){
			index = i;
		}
	}
	
	if(index == -1){
		return result;
	}	
	//console.log('findVariantsByKeyValue '+key+' '+value+' \nlooking for index: '+index+'['+key+']');
		 
	for(i in  variantArray){
		variant = variantArray[i];	
		//console.log('--> '+variant.options[index]+' '+value);	
		if(variant.options[index] == value){
				result.push(variant);
		}			
	}
	return result;
}


function buildSelectors(){
	$('#product-select-'+thisProductId).hide();
	
	$('#product-select-'+thisProductId).parent().append('<div id="top-products"></div>');
	$('#product-select-'+thisProductId).parent().append('<div id="bottom-products"></div>');
	selectorForProduct('top-products',topProducts,'');
	selectorForProduct('bottom-products',bottomProducts,'');
		
	
	if(hasBottomProducts == false){
		$('#bottom-products').hide();
		$('.select-label').hide();
	}else{
		
	}
	//selectCallBack();
	customDecoration();
	if(thisProduct.available == true){		
		addSizeSwatches();
		addColorSwatches();
	}else{
		
		addColorSwatchesForSoldOut();
	}
	
}




function customDecoration(){
	
	if(hasBottomProducts == true){
		$('#top-products .label-for-Size').html('Select Top');
		//$('#top-products .label-for-Size').hide();
		$('#bottom-products .label-for-Size').html('Select Bottom');
		//$('#bottom-products .label-for-Size').hide();
		
		$('#top-products .select-Size option:first-of-type').text('Select top size');
		$('#bottom-products .select-Size option:first-of-type').text('Select bottom size');
		
		$('#top-products .label-for-Color').hide();
		$('#top-products .select-Color option:first-of-type').text('Select color');
		//$('#top-products .label-for-Color').css({'opacity':0.5});
		
		
		$('#bottom-products .select-Color').hide();
		$('#bottom-products .label-for-Color').hide();
		//var topProducts = $('#bottom-products .label-for-Size').clone()
		//$('#top-products .label-for-Size').html('Select top size');		
		//$('#bottom-products .label-for-Size').html('Select bottom size');
		
		
	}else{
		$('#top-products .label-for-Size').html('Select Size');
		
		
		$('#top-products .select-Size option:first-of-type').text('Select Size');
		//$('#top-products .label-for-Size').hide();
		
		$('#top-products .select-Color option:first-of-type').text('Select Color');
		$('#top-products .label-for-Color').hide();
	}
	$('#top-products .select-Size').before($('#top-products .select-Color'));	
}



function addSizeSwatches(){
	
	var myCount = 1;
	$('.select-Size').each(function(){	
		
		$(this).attr('id','size-selector-'+myCount);
		$(this).before('<div id="size-picker'+myCount+'" class="size-picker " ></div>');
		
		
		$(this).find('option').each(function(){
			var sizeValue = $(this).attr('value');
			if('' != sizeValue){
				
				$('#size-picker'+myCount).append(addSizeSwatch(sizeValue,'size-selector-'+myCount,myCount));
			}
		});			
		myCount++; 	
	});
		
	$('.select-Size').hide();	
}

function addColorSwatchesForSoldOut(){
	$('.price_outer').before('<div id="swatch-picker" class="swatch-picker " ><label class="label-for-Color">Select Color</label><div class="color-display isflat" ></div></div>');
	var myCount = 1;
	var indexOfColorOption = -1;
	for(var i = 0; i <  thisProduct.options.length; i++){
		//console.log(thisProduct.options[i].toLowerCase());
		if(thisProduct.options[i].toLowerCase() == 'color'){
			indexOfColorOption = i;
		}
	}
	
	for(i in  thisProduct.variants){
		variant = thisProduct.variants[i];
		var colorValue = variant.options[indexOfColorOption];
		$('#swatch-picker').append(addColorSwatch(colorValue,'color-selector-'+myCount,myCount));
		
	}
	
	$('.color-swatch').each(function(){	
			//$(this).find('a').attr('href',"#");
			//$(this).find('a').css({'cursor':'default'});
	});
	
}

function addColorSwatches(){
	
	var myCount = 1;
	$('.select-Color').each(function(){	
		
		$(this).attr('id','color-selector-'+myCount);
		$(this).parent().prepend('<div id="swatch-picker'+myCount+'" class="swatch-picker  " ><label class="label-for-Color">Select Color</label><div class="color-display isflat" ></div></div>');
		
		
		$(this).find('option').each(function(){
			var colorValue = $(this).attr('value');
			if('' != colorValue){
				
				$('#swatch-picker'+myCount).append(addColorSwatch(colorValue,'color-selector-'+myCount,myCount));
			}
		});			
		myCount++; 	
	});
	
	$('#bottom-products .swatch-picker').hide();
	$('.select-Color').hide();	
}

function addColorSwatch(colorValue,target,myCount){
	var colorValueImg = replaceBlanks(colorValue);
	return '<div class="color-swatch color-'+colorValueImg+'" ><a href="javascript:selectColor(\''+colorValue+'\',\''+target+'\'\,\''+colorValueImg+'\',\''+myCount+'\')" ><img src="'+assetUrl+colorValueImg+'.jpg?=v2" alt="'+colorValueImg+'.jpg" title="'+colorValue+'" /></a></div>';
	
}

function addSizeSwatch(sizeValue,target,myCount){
	var sizeValueImg = replaceBlanks(sizeValue);
	return '<a class="size-swatch size-'+sizeValueImg+'" href="javascript:selectSize(\''+sizeValue+'\',\''+target+'\'\,\''+sizeValueImg+'\',\''+myCount+'\')" ><div  >'+sizeValue+'</div></a>';
	
}

function replaceBlanks(string){
	var string = string.replace(/ /g,'-');
	string = string.replace('é','e');
	string = string.replace('/','-');
	return string.toLowerCase();
}


function selectSize(sizeValue,target,key,myCount){
	$('#size-picker'+myCount+' .size-swatch').removeClass('active');
	$('#size-picker'+myCount+' .size-'+key).addClass('active');
	
	$('#'+target).val(sizeValue);
	
	multiCartCallback();
}



function selectColor(colorValue,target,key,myCount){
	
	$('.color-swatch').removeClass('active');
	$('.color-'+key).addClass('active');
	
	$('#'+target).val(colorValue);
	$('#swatch-picker'+myCount+' .color-display').html(colorValue);
	$('#swatch-picker'+myCount+' .color-display').removeClass('isflat');
	
	if(hasBottomProducts == true){	
		syncColorSelection();
	}	
	
	// for sold outs
	if(thisProduct.available != true){
		$('#swatch-picker .color-display').html(colorValue);
		$('#swatch-picker .color-display').removeClass('isflat');
	}
	multiCartCallback();
}

function selectorForProduct(key,dataArray,header){
	
	$('#'+key).append(header);
	var hasPart = false;
	for(var t = 0; t <  thisProduct.options.length; t++){
		
		$('#'+key).append('<label class="label-for-'+thisProduct.options[t]+'" >'+thisProduct.options[t]+'</label><select class="select-'+thisProduct.options[t]+'" name="'+thisProduct.options[t]+'" ><option value="" >Select</option></select>');
		var duplicates = [];
		for(var i = 0; i <  dataArray.length; i++){
				
				if($.inArray(dataArray[i].options[t],duplicates) == -1){
					duplicates.push(dataArray[i].options[t]);
					$('#'+key+' .select-'+thisProduct.options[t]).append('<option  value="'+dataArray[i].options[t]+'" >'+dataArray[i].options[t]+'</option>');
				} 
				//$('#'+key+' .select-'+thisProduct.options[t]).append('<option value="'+dataArray[i].id+'" >'+dataArray[i].options[t]+dataArray[i].soldHtml+dataArray[i].id+'</option>');			
			
		}
			
		if('part' == thisProduct.options[t].toLowerCase()){
			//console.log('is part');
			$('#'+key+' .select-'+thisProduct.options[t]+' option:nth-of-type(2)').attr('selected', 'selected');
			$('#'+key+' .select-'+thisProduct.options[t]).hide();
			$('#'+key+' .label-for-'+thisProduct.options[t]).hide();
		}
	}
	
	
	if(hasPart == true){
		
	}
}


function eknyAddToCart(){
	//console.log('eknyAddToCart');
	
	if('blocked' == $('.my-add').attr('data-blocked')){
		alert('The product is either sold out or you need to make a valid selection');	
		return;
	}
	 
	selectedObject.quantity = $('input[name=quantity]').val();
	delete selectedObject.price;
	delete selectedObject.available;		
	
	 
	 if(hasBottomProducts == true){
		 
		 selectedObject2.quantity = $('input[name=quantity]').val();	
		 delete selectedObject2.price;
		 delete selectedObject2.available;
		 
		 $.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: selectedObject,
			success: delayedAddToCart,
			error: addToCartFail
		 });
       
       
       	
     }else{
     // normal requests  
       	$.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: selectedObject,
            success: addToCartOk,
            error: addToCartFail
		});
       
     }
	
}


function delayedAddToCart(){
  $('#ProductMain').animate({'opacity':0.1});	
  // ODD shopify issue ajax needs to be called with delay
  setTimeout(function(){ addSecondObjectToCart()}, 3000);


}


function addSecondObjectToCart(){
    console.log('addSecondObjectToCart');
    $('#ProductMain').animate({'opacity':1});	
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: selectedObject2,
      success: eknyAddToCartOk,
      error: addToCartFail
    });  
}




function eknyAddToCartOkVoid(product){
	//just catches the event
	var addedQuantity = parseInt($('.quantity').val());
	cartCount = cartCount + addedQuantity; 
	
	if($('.open-product').html() == "Your cart is currently empty.") { 
		$('.open-product').html(''); 
	}
	if($('.cart-count').length) { 
		$('.cart-count').text(cartCount);
	} else { 
		$('#CartButton').append('(<span class="cart-count">' + cartCount + '</span>)'); 
	}
}

function eknyAddToCartOkBak(){
/*
	  $('html, body').animate({ scrollTop: 0 }, 200); 
      var addedID = thisProduct.id; 
      var addedQuantity = parseInt($('.quantity').val());
	  if(hasBottomProducts == true){
	   	addedQuantity = addedQuantity*2 
	  }
	   
	  cartCount = cartCount + addedQuantity; 
	  if($('.open-product').html() == "Your cart is currently empty.") { 
	    $('.open-product').html(''); 
	  }
	  if($('.cart-count').length) { 
        $('.cart-count').text(cartCount);
	  } else { 
        $('#CartButton').append('(<span class="cart-count">' + cartCount + '</span>)'); 
	  }
      
      // YOU JUST ADDED! action 
        
      var newAddedImg = product.image;
      var newAddedItem = ''; 
      newAddedItem += "You just added:" + '<div class="open-product-inner clearfix" data-product-id="' + addedID + '">'; 
      newAddedItem += '<img src="' + newAddedImg + '" alt="" width="50"/>';
      newAddedItem += '<div class="product-info"><span class="product-title">';
      newAddedItem += product.title + ' (' + addedQuantity + ')'; 
      newAddedItem += '</span></div></div>';
      $('.open-product').html(newAddedItem);

	    totalMonies = totalMonies + (product.price*addedQuantity);
	    var newPrice = totalMonies*0.01; 
        if(newPrice < 1) { 
            var newPriceFormatted = addCommas(newPrice); 
        } else { 
            var newPriceFormatted = newPrice.toFixed(2); 
        }
	    $('.open-product-count').html("Subtotal" + ': '); 

        var currencyFormatted = Shopify.formatMoney(newPriceFormatted, "<span class=money>${{amount}}</span>");
       
        $('.open-product-cost').html('<span class="money">' + currencyFormatted + '</span>');
        
        // CURRENCY // 
        
        	Currency.convertAll('USD', $('#currencies span.selected').attr('data-currency'), 'span.money', 'money_format');
        
         
        $('#CartAddNotification').addClass('added').fadeIn(500).delay(3000).fadeOut(300, function() { 
            $(this).removeClass('added'); 
        }); 
*/
}